import axios from "axios";
import qs from "querystring";

import ToastService from "./toast-service";
import RedirectService from "./redirect-service";
import { SERVER_BASE_URL } from "../config";

const toasty = (data) => {
  const { error, info, redirect } = data;
  if (error) ToastService.errorToast(error);
  if (info) ToastService.infoToast(info);
  if (redirect) RedirectService.redirect(redirect);
};

const importUrl = async ({ url }) => {
  const fetchUrl = `${SERVER_BASE_URL}/playlist/import?${qs.stringify({
    url,
  })}`;

  const {
    data: { payload, error, info },
  } = await axios.get(fetchUrl, { withCredentials: true });

  if (error) {
    ToastService.errorToast(error);
    return null;
  }
  if (info) ToastService.infoToast(info);
  console.log(payload);
  return payload;
};

const convert = async ({ songs }) => {
  const url = `${SERVER_BASE_URL}/playlist/convert`;
  const config = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    withCredentials: true,
  };
  const body = {
    songs: JSON.stringify(songs),
  };
  const { data } = await axios.post(url, qs.stringify(body), config);
  toasty(data);
  const { payload: youtubeVideos } = data;
  return youtubeVideos;
};

const createNewPlaylist = async ({ songs, name }) => {
  const url = `${SERVER_BASE_URL}/playlist/create`;
  const config = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    withCredentials: true,
  };
  const body = {
    name,
    songs: JSON.stringify(songs),
  };
  const { data } = await axios.post(url, qs.stringify(body), config);
  toasty(data);
  const { payload: playlistId } = data;

  return playlistId;
};

const addSongs = async ({ songs, id }) => {
  const url = `${SERVER_BASE_URL}/playlist/songs/add`;
  const config = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    withCredentials: true,
  };
  const body = {
    id,
    songs: JSON.stringify(songs),
  };
  const { data } = await axios.post(url, qs.stringify(body), config);
  toasty(data);
  const { payload: done } = data;

  return done;
};

// songs = [videoId,videoId]
const deleteSongs = async ({ songs, id }) => {
  const url = `${SERVER_BASE_URL}/playlist/songs/delete`;
  const config = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    withCredentials: true,
  };
  const body = {
    id,
    songs: JSON.stringify(songs),
  };
  const { data } = await axios.post(url, qs.stringify(body), config);
  toasty(data);
  const { payload: done } = data;

  return done;
};

// fetch all playlist of this user
const getAllPlaylist = async ({ username }) => {
  const url = `${SERVER_BASE_URL}/playlist/all?${qs.stringify({
    username,
  })}`;
  const {
    data: { payload, error },
  } = await axios.get(url, { withCredentials: true });

  if (error) ToastService.errorToast(error);

  if (payload) return payload;

  return null;
};

// fetch playlist
const getPlaylist = async ({ id }) => {
  const url = `${SERVER_BASE_URL}/playlist/songs?${qs.stringify({
    id: id,
  })}`;
  const {
    data: { payload, error },
  } = await axios.get(url, { withCredentials: true });

  if (error) ToastService.errorToast(error);

  if (payload) return payload;

  return null;
};

const deletePlaylist = async ({ id }) => {
  const url = `${SERVER_BASE_URL}/playlist/delete?${qs.stringify({
    id,
  })}`;
  const { data } = await axios.get(url, { withCredentials: true });
  toasty(data);
  const { payload } = data;
  return payload;
};

const editPlaylist = async ({
  id,
  name,
  makePublic,
  makePrivate,
  thumbnail,
}) => {
  const url = `${SERVER_BASE_URL}/playlist/edit?${qs.stringify({
    id,
    name,
    makePublic,
    makePrivate,
    thumbnail,
  })}`;
  const { data } = await axios.get(url, { withCredentials: true });
  toasty(data);
  const { payload } = data;
  return payload;
};

const saved = async () => {
  const url = `${SERVER_BASE_URL}/playlist/saved`;
  const { data } = await axios.get(url, { withCredentials: true });
  toasty(data);
  const {
    payload: { songs: savedSongs },
  } = data;
  return savedSongs;
};

export default {
  createNewPlaylist,
  importUrl,
  getAllPlaylist,
  getPlaylist,
  addSongs,
  deleteSongs,
  deletePlaylist,
  editPlaylist,
  saved,
  convert,
};
